import React from "react";
import "../../styles/PrivacyPolicy.css";
import { siteUrl } from "../Blogs/data";
import { Helmet } from "react-helmet";
const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>{"Orion Stars 777 Slots - Privacy Policy"}</title>
        <meta
          name="description"
          content={
            "We value your privacy and are committed to handling your data responsibly and in compliance with all relevant data protection laws."
          }
        />
        <link
          rel="canonical"
          href={`${siteUrl}/privacy-policy/orion-stars-777-slots-privacy-policy`}
        />
        {/* OG Tags */}
        <meta
          property="og:title"
          content={"Orion Stars 777 Slots - Privacy Policy"}
        />
        <meta property="og:site_name" content="Orion star 777 Slots/" />
        <meta
          property="og:url"
          content={`${siteUrl}/privacy-policy/orion-stars-777-slots-privacy-policy`}
        />
        <meta
          property="og:description"
          content={
            "We value your privacy and are committed to handling your data responsibly and in compliance with all relevant data protection laws."
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={""} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="privacyPolicy__container">
        <h1>Orion Stars Privacy Policy</h1>
        <h3>Privacy Policy</h3>
        <span>
          This Privacy Policy outlines how Orion Stars Online (“we,” “us,” or
          “our”) collects, uses, and protects your personal information when you
          use our software, Orion Stars online (“Software”), and our
        </span>
        <div>
          website, <a href="https://orionstar777slots.com/">
          https://orionstar777slots.com/</a>
        </div>
        <span>
          We value your privacy and are committed to handling your data
          responsibly and in compliance with all relevant data protection laws.
          This policy details the types of information we collect, how we use
          it, and the rights you have regarding your data. By using our Software
          and website, you acknowledge and agree to the terms of this policy.
          Your trust is important to us, and we are dedicated to safeguarding
          your personal information with the highest standards of security.
        </span>
        <h3>User-Provided Information and How We Use Them</h3>
        <span>
          When you sign up or register with Orion Stars, we collect the
          information you choose to provide. While registration is optional,
          please note that some features of our software may be inaccessible
          without it.
        </span>
        <span>
          When you create an account and use our Software, we typically collect
          the following:
        </span>
        <span>
          (a) Personal details such as your name, phone number, email address,
          username, password, and other registration information;
        </span>
        <span>
          (b) Any additional information you share with us when reaching out for
          support;
        </span>
        <span>
          (c) Data you enter into our system while using the Software, like
          contact details and more.
        </span>
        <span>
          This helps us tailor your experience and provide the best possible
          service while maintaining your privacy.
        </span>
        <h3>Purpose</h3>
        <span>We use the information you provide to:</span>
        <div className="textWithBullets__container">
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>Set up and personalize your account to suit your needs.</span>
          </div>
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>
              Tailor content and features that are most relevant to you.
            </span>
          </div>
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>
              Verify your identity and ensure the security of your account.
            </span>
          </div>
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>
              Gather statistical insights or conduct surveys to enhance our
              website and services.
            </span>
          </div>
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>
              Help you quickly find the information and services you need.
            </span>
          </div>
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>
              Streamline your experience by minimizing repetitive data entry.
            </span>
          </div>
          <div className="textWithBullets">
            <span className="dot">•</span>
            <span>
              Send you updates and information about our services via email.
            </span>
          </div>
        </div>
        <span>
          By using Orion Stars, you agree to be contacted by us through phone,
          email, or written correspondence, and acknowledge that this will not
          be considered a violation of your rights under applicable data laws.
        </span>
        <h3>Automatically Collected Information</h3>
        <span>
          When you use Orion Stars, we may automatically collect certain
          information, such as the type of device you use, your device's unique
          ID, your IP address, your device’s operating system, the browsers you
          access, and details on how you interact with the Software.
        </span>
        <span>
          Additionally, we may use GPS or similar technologies to determine your
          current location to show relevant location-based content and
          advertisements. Rest assured, your current location will not be shared
          with other users or partners.
        </span>
        <span>
          If you prefer not to have your location used for these purposes, you
          can disable location services in your device settings for the
          software.
        </span>
        <h3>Legitimate Interest</h3>
        <span>
          We only share your information with third parties as this privacy
          policy outlines.
        </span>
        <span>
          We may disclose User-Provided and Automatically Collected Information
          under the following circumstances:
        </span>
        <span>
          When required by law, such as to respond to a subpoena or similar
          legal process.
        </span>
        <span>
          When we believe, in good faith, that it’s necessary to protect our
          rights, ensure your safety or the safety of others, investigate fraud,
          or respond to government requests.
        </span>
        <span>
          With trusted service providers who act on our behalf, have no
          independent use of your information, and agree to comply with the
          terms of this privacy policy.
        </span>
        <span>
          If Orion Stars is part of a merger, acquisition, or sale of all or
          part of its assets, we will notify you via email and/or a visible
          notice on our website. This will include details about any changes in
          ownership or how your information may be used, as well as any choices
          you have regarding your information.
        </span>
        <h3>What are my opt-out rights?</h3>
        <span>
          You can stop the software from collecting information at any time.
          Simply uninstall or disable the software on your device to prevent
          further data collection, where applicable.
        </span>
        <h3>Data Retention Policy, Managing Your Information</h3>
        <span>
          We will keep User-Provided data for as long as you continue to use the
          Software, and for a reasonable period afterward. Automatically
          Collected information will be stored for up to 24 months, after which
          it may be retained in an aggregated form. Keep in mind that certain
          User-Provided Data may be essential for the Software to function
          properly.
        </span>
        <h3>Security</h3>
        <span>
          We take the protection of your information seriously and employ a
          range of physical, electronic, and procedural safeguards to keep it
          secure. Access to your data is limited to authorized employees and
          contractors who require it to operate, develop, or enhance our
          Software.
        </span>
        <span>
          While we strive to provide strong security for the information we
          process and maintain, it's important to note that no security system
          is foolproof, and we cannot guarantee complete prevention of potential
          breaches.
        </span>
        <h3>Media</h3>
        <span>
          When uploading images to our website, please be mindful of embedded
          location data (EXIF GPS). Visitors can extract this type of
          information, so we recommend removing it before uploading. This helps
          protect your privacy and ensures that location details aren't shared
          unintentionally.
        </span>
        <h3>Embedded content from other websites</h3>
        <span>
          Our articles may contain embedded content such as videos, images, or
          articles. This embedded content functions just like if you were
          visiting the other website. As such, these external sites may collect
          your data, use cookies, and incorporate additional tracking
          mechanisms. They may also monitor your interaction with the embedded
          content, especially if you’re logged into that site.
        </span>
        <h3>Data Processing</h3>
        <span>
          Our cloud providers may store and process data in various countries
          where they operate. Rest assured, we are committed to taking all
          necessary measures to protect your privacy and ensure your data
          remains secure.
        </span>
        <h3>Changes</h3>
        <span>
          We may update this Privacy Policy occasionally to reflect changes for
          any reason. When updates are made, we’ll let you know by posting the
          revised policy here and notifying you through a website pop-up, email,
          or in-software message. We encourage you to review this policy
          regularly, as continued use of our site means you accept any changes
          made.
        </span>
        <h3>Your Rights</h3>
        <span>
          Under applicable data protection laws, you are entitled to the
          following:
        </span>
        <div className="numberText--keyValue__container">
          <div className="numberText--keyValue">
            <span>1.</span>
            <span className="numberText__key">Access Your Data: </span>
            <span className="numberText__value">
              You can request details about the personal data we hold and how
              it’s being processed.
            </span>
          </div>
          <div className="numberText--keyValue">
            <span>2.</span>
            <span className="numberText__key">
              Correct or Complete Information:
            </span>
            <span className="numberText__value">
              If your data is incorrect or incomplete, you have the right to ask
              us to correct or complete it.
            </span>
          </div>
          <div className="numberText--keyValue">
            <span>3.</span>
            <span className="numberText__key">Delete Your Data: </span>
            <span className="numberText__value">
              You can request the deletion of your personal data when it has
              been processed unlawfully or where our lawful basis is consent.
            </span>
          </div>
          <div className="numberText--keyValue">
            <span>4.</span>
            <span className="numberText__key">Restrict Processing:</span>
            <span className="numberText__value">
              You can limit how your data is processed under specific
              circumstances.
            </span>
          </div>
          <div className="numberText--keyValue">
            <span>5.</span>
            <span className="numberText__key">Data Portability:</span>
            <span className="numberText__value">
              You have the right to request your personal data in an electronic
              format for your use or transfer to another provider.
            </span>
          </div>
          <span>
            You can also withdraw any consent you’ve previously given so we can
            process your personal data anytime. Please note, however, that this
            withdrawal won’t impact data we are legally required to retain for
            administrative, legal, or security purposes.
          </span>
          <span>
            If you’d like to exercise any of these rights, feel free to reach
            out to us. We’re here to help!
          </span>
          <h3>Data Breach</h3>
        </div>
        <span>
          At Orion Stars, safeguarding your personal information is our top
          priority. We implement robust measures to protect your data against
          loss, misuse, unauthorized access, disclosure, alteration, or
          destruction. Your privacy choices are respected and honored at every
          step.{" "}
        </span>
        <span>
          In the rare event of unforeseen circumstances resulting in a data
          breach, you will be notified within 72 hours of identifying such a
          breach.
        </span>
        <h3>Contact forms - Cookies</h3>
        <span>
          When you leave a comment on our website, you can choose to save your
          name, email, and website in cookies for easier future interactions.
          These cookies last for one year, saving you the hassle of re-entering
          details.
        </span>
        <span>
          If you log in to our site, we’ll set a temporary cookie to check if
          your browser accepts cookies. This cookie doesn’t store personal data
          and disappears once you close your browser. Upon logging in, we
          establish cookies to store your login information and screen
          preferences—login cookies last for two days, while screen preference
          cookies stay for a year. Opting for “Remember Me” extends your login
          for two weeks, and logging out removes these cookies.
        </span>
        <span>
          For contributors, editing or publishing an article saves a temporary
          cookie with the article’s ID, expiring after one day.
        </span>
        <span>
          Comments and their metadata are stored indefinitely to streamline
          future moderation. To enhance spam protection, we collect details from
          the comments form, including the visitor’s IP address and browser user
          agent.
        </span>
        <h3>Your Consent</h3>
        <span>
          By using the Orion Stars software and website, you agree to the
          processing of your information as described in this Privacy Policy,
          including any future updates. “Processing” refers to actions like
          using cookies on your device or interacting with your data in various
          ways—this includes collecting, storing, deleting, using, combining, or
          sharing your information. All processing activities are securely
          managed on our servers to ensure your data is handled with care and in
          accordance with our privacy standards.
        </span>
        <h3>Agreement and Litigation</h3>
        <span>
          By using Orion Stars’ software and support services, you agree to the
          terms outlined in this Privacy Policy and any other agreements we may
          have with you. If you do not accept these terms, please refrain from
          using our software or website. Any disputes related to privacy or the
          terms in this Privacy Policy or any other agreement with us will be
          governed by U.S. law. You also agree to resolve such disputes through
          arbitration (using our contact form) and to adhere to any damage
          limitations specified in our agreements.
        </span>
        <h3>Users from Outside the USA</h3>
        <span>
          If you access Orion Stars from outside the USA, your information may
          be processed, stored, and transferred to AITC, NP, where our central
          database is located. Data protection laws in the USA might not be as
          extensive as those in your country. However, we are dedicated to
          taking all necessary measures to protect your privacy and ensure the
          safety of your information.
        </span>
        <h3>Contact Details, Complaints, and Questions</h3>
        <span>
          If you have any questions about our Privacy Policy, you can contact us
          through our contact form or email.
        </span>
      </div>
    </>
  );
};

export default PrivacyPolicy;
